<ng-container *ngIf="plateforme.isMobile() else blocHeaderPortail">
  <div class="mobile" [ngClass]="{'isValid': contentIsValid}">
    <ion-icon *ngIf="!contentIsValid" src="./assets/svg/{{icone}}.svg"></ion-icon>
    <ion-icon *ngIf="contentIsValid" src="./assets/svg/check_circle_white.svg"></ion-icon>

    <p class="typo-16-bold-white">{{title}}</p>
  </div>
</ng-container>

<ng-template #blocHeaderPortail>
  <div class="portail" [ngClass]="{'isValid': contentIsValid}">
    <ion-icon *ngIf="!contentIsValid" src="./assets/svg/{{icone}}.svg"></ion-icon>
    <ion-icon *ngIf="contentIsValid" src="./assets/svg/check_circle_white.svg"></ion-icon>

    <p class="typo-16-bold-white">{{title}}</p>
  </div>
</ng-template>

